import { setTimeout } from "core-js";
import icons from "url:../../img/icons.svg";

export default class View {
    _data;

    render(data, render = true) {
        if (!data || (Array.isArray(data) && data.length === 0))
            return this.renderError();

        this._data = data;
        const markup = this._generateMarkup();

        if (!render) return markup;

        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }

    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        // converting this markup string to DOM object so that we can compare it
        // and check which things are changed and only need to be updated in ui
        // converting that string into real DOM OR >>> VIRTUAL DOM <<< -> Dom that lives in memory
        const newDOM = document
            .createRange()
            .createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = this._parentElement.querySelectorAll("*");
        newElements.forEach((newEl, i) => {
            const curEl = curElements[i];

            // updates changed text in the dom
            if (
                !newEl.isEqualNode(curEl) &&
                newEl.firstChild?.nodeValue.trim() !== ""
            ) {
                curEl.textContent = newEl.textContent;
            }
            // updates changed attributes
            if (!newEl.isEqualNode(curEl)) {
                Array.from(newEl.attributes).forEach((attr) =>
                    curEl.setAttribute(attr.name, attr.value)
                );
            }
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }

    renderError(message = this._errorMessage) {
        const markup = `
              <div class="error">
                <div>
                  <svg>
                    <use href="${icons}#icon-alert-triangle"></use>
                  </svg>
                </div>
                <p>${message}</p>
              </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }

    renderSpinner() {
        const markup = `
              <div class="spinner">
                <svg>
                  <use href="${icons}#icon-loader"></use>
                </svg>
              </div> 
            `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }

    renderWelcomeMessage() {
        const msg = `<div class="message">
                        <div>
                            <svg>
                                <use href="${icons}#icon-smile"></use>
                            </svg>
                        </div>
                        <p>
                            Start by searching for a recipe or an ingredient. Have
                            fun!
                        </p>
                    </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", msg);
    }

    renderMessage(message = this._message) {
        const msg = `<div class="message" >
                      <div>
                          <svg>
                              <use href="${icons}#icon-smile"></use>
                          </svg>
                      </div>
                      <p>
                          ${message}
                      </p>
                  </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("beforeend", msg);
    }
    resetForm() {
        const markup = "";
        this._clear();
        this._parentElement.insertAdjacentHTML("beforeend", markup);
    }
}
